module.exports = __webpack_public_path__ + "4917a7900dc3e2c298279c15a1e1f762.png";